import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type CreateAccountConnectionMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.CreateAccountConnectionInput;
}>;

export type CreateAccountConnectionMutationResult = { __typename?: 'Mutation' } & {
  createAccountConnection?: GraphQLTypes.Maybe<
    { __typename?: 'CreateAccountConnectionPayload' } & {
      errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message' | 'path'>>>;
    }
  >;
};

export const CreateAccountConnectionMutationDocument = gql`
  mutation createAccountConnectionMutation($input: CreateAccountConnectionInput!) {
    createAccountConnection(input: $input) {
      errors {
        message
        path
      }
    }
  }
`;
